import { Tooltip } from 'antd';
import { useTranslate } from '@tolgee/react';
import LockHandler from 'components/LockHandler';
import Icon, { PoweroffOutlined } from '@ant-design/icons';
import { ReactComponent as SvgRestart } from 'views/Conversation/ConvList/assets/restart.svg';
import { useConvReceptionClose, useConvReceptionReopen } from 'hooks/business/useConvReception';
import { useCallback } from 'react';
import { useKeyboardHandler } from 'hooks/useKeyboardManager';
import { KEYBOARD_PRIORITY } from 'hooks/useKeyboardManager/KeyboardEventManager';

interface ReceptionProps {
  conversation: Conversation.Conversation;
}

const RestartIcon = (props: { onClick: () => void }) => <Icon component={SvgRestart} {...props} />;

export function Reception(props: ReceptionProps) {
  const { conversation } = props;
  const { inReception, processed, conversationId } = conversation;

  const closeReception = useConvReceptionClose();
  const reopenReception = useConvReceptionReopen();

  const { t } = useTranslate();
  const isInReception = inReception || !processed;

  const close = useCallback(() => {
    return closeReception(conversation);
  }, [closeReception, conversation]);

  const reopen = useCallback(() => {
    return reopenReception(conversation);
  }, [reopenReception, conversation]);

  useKeyboardHandler(
    ['Escape'],
    () => {
      close();
    },
    {
      eventType: 'keydown',
      priority: KEYBOARD_PRIORITY.PAGE,
      context: () => inReception && conversationId !== '0',
      stopPropagation: true,
    },
  );

  if (isInReception) {
    return (
      <Tooltip
        placement="top"
        title={t('scene.chatWorkspace.currentConversation.action.closeConversationWithShortcut', {
          shortcut: 'Esc',
        })}
      >
        <LockHandler
          className="[&_svg]:w-[18.5px] [&_svg]:h-[18.5px]"
          Component={PoweroffOutlined}
          handlerKey="onClick"
          onClick={close}
        />
      </Tooltip>
    );
  }

  return (
    <Tooltip
      placement="top"
      title={t('scene.chatWorkspace.currentConversation.action.reopenConversation')}
    >
      <LockHandler Component={RestartIcon} handlerKey="onClick" onClick={reopen} />
    </Tooltip>
  );
}
